module.exports = function() {
  return new Worker(__webpack_public_path__ + "bfcbc858787fdf3a2b68.worker.js");
};